{
  "about.blocks": "Модерирани сървъри",
  "about.contact": "За контакти:",
  "about.default_locale": "По подразбиране",
  "about.disclaimer": "Mastodon е безплатен софтуер с отворен изходен код и търговска марка на Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Няма налична причина",
  "about.domain_blocks.preamble": "Mastodon обикновено позволява да разглеждате съдържание и да взаимодействате с други потребители от всякакви сървъри във Федивселената. Има изключения, направени конкретно за този сървър.",
  "about.domain_blocks.silenced.explanation": "Обикновено няма да виждате профили и съдържание, освен ако изрично не го потърсите или се включете в него, следвайки го.",
  "about.domain_blocks.silenced.title": "Ограничено",
  "about.domain_blocks.suspended.explanation": "Никакви данни от този сървър няма да се обработват, съхраняват или обменят, правещи невъзможно всяко взаимодействие или комуникация с потребители от тези сървъри.",
  "about.domain_blocks.suspended.title": "Спряно",
  "about.language_label": "Език",
  "about.not_available": "Тази информация не е публична на този сървър.",
  "about.powered_by": "Децентрализирана социална мрежа, захранвана от {mastodon}",
  "about.rules": "Правила на сървъра",
  "account.account_note_header": "Лична бележка",
  "account.add_or_remove_from_list": "Добавяне или премахване от списъци",
  "account.badges.bot": "Бот",
  "account.badges.group": "Група",
  "account.block": "Блокиране на @{name}",
  "account.block_domain": "Блокиране на домейн {domain}",
  "account.block_short": "Блокиране",
  "account.blocked": "Блокирани",
  "account.cancel_follow_request": "Оттегляне на заявката за последване",
  "account.copy": "Копиране на връзка към профила",
  "account.direct": "Частно споменаване на @{name}",
  "account.disable_notifications": "Спиране на известяване при публикуване от @{name}",
  "account.edit_profile": "Редактиране на профила",
  "account.edit_profile_short": "Редактиране",
  "account.enable_notifications": "Известяване при публикуване от @{name}",
  "account.endorse": "Представи в профила",
  "account.familiar_followers_many": "Последвано от {name1}, {name2}, и {othersCount, plural, one {един друг, когото познавате} other {# други, които познавате}}",
  "account.familiar_followers_one": "Последвано от {name1}",
  "account.familiar_followers_two": "Последвано от {name1} и {name2}",
  "account.featured": "Препоръчано",
  "account.featured.accounts": "Профили",
  "account.follow": "Последване",
  "account.follow_back": "Последване взаимно",
  "account.follow_request_cancel": "Отказване на заявката",
  "account.follow_request_cancel_short": "Отказ",
  "account.follow_request_short": "Заявка",
  "account.followers": "Последователи",
  "account.followers.empty": "Още никой не следва потребителя.",
  "account.followers_counter": "{count, plural, one {{counter} последовател} other {{counter} последователи}}",
  "account.followers_you_know_counter": "{counter} познавате",
  "account.following": "Последвано",
  "account.following_counter": "{count, plural, one {{counter} последван} other {{counter} последвани}}",
  "account.follows.empty": "Потребителят още никого не следва.",
  "account.follows_you": "Следва ви",
  "account.go_to_profile": "Към профила",
  "account.hide_reblogs": "Скриване на подсилвания от @{name}",
  "account.in_memoriam": "В памет на.",
  "account.joined_short": "Дата на присъединяване",
  "account.languages": "Промяна на езиците, за които сте абонирани",
  "account.link_verified_on": "Собствеността върху тази връзка е проверена на {date}",
  "account.locked_info": "Състоянието за поверителността на акаунта е зададено заключено. Собственикът преглежда ръчно от кого може да се следва.",
  "account.media": "Мултимедия",
  "account.mention": "Споменаване на @{name}",
  "account.moved_to": "Лицето {name} посочи, че новият му акаунт е вече:",
  "account.mute": "Заглушаване на @{name}",
  "account.mute_notifications_short": "Заглушаване на известията",
  "account.mute_short": "Заглушаване",
  "account.muted": "Заглушено",
  "account.mutual": "Взаимно се следвате",
  "account.no_bio": "Няма представен опис.",
  "account.open_original_page": "Отваряне на първообразната страница",
  "account.posts": "Публикации",
  "account.remove_from_followers": "Премахване на {name} от последователи",
  "account.report": "Докладване на @{name}",
  "account.requested_follow": "{name} поиска да ви последва",
  "account.share": "Споделяне на профила на @{name}",
  "account.show_reblogs": "Показване на подсилвания от @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} публикация} other {{counter} публикации}}",
  "account.unblock": "Отблокиране на @{name}",
  "account.unblock_domain": "Отблокиране на домейн {domain}",
  "account.unblock_domain_short": "Отблокиране",
  "account.unblock_short": "Отблокиране",
  "account.unendorse": "Не включвайте в профила",
  "account.unfollow": "Стоп на следването",
  "account.unmute": "Без заглушаване на @{name}",
  "account.unmute_notifications_short": "Включване на известията",
  "account.unmute_short": "Без заглушаване",
  "account_note.placeholder": "Щракнете, за да добавите бележка",
  "admin.dashboard.daily_retention": "Ниво на задържани на потребители след регистрация, в дни",
  "admin.dashboard.monthly_retention": "Ниво на задържани на потребители след регистрация, в месеци",
  "admin.dashboard.retention.average": "Средно",
  "admin.dashboard.retention.cohort": "Регистрации за месец",
  "admin.dashboard.retention.cohort_size": "Нови потребители",
  "admin.impact_report.instance_accounts": "Профили на акаунтите, които ще се изтриват",
  "admin.impact_report.instance_followers": "Последователите на потребителите ни биха загубили",
  "admin.impact_report.instance_follows": "Последователите на потребителите им биха загубили",
  "admin.impact_report.title": "Обобщено въздействие",
  "alert.rate_limited.message": "Опитайте пак след {retry_time, time, medium}.",
  "alert.rate_limited.title": "Скоростта е ограничена",
  "alert.unexpected.message": "Възникна неочаквана грешка.",
  "alert.unexpected.title": "Опаа!",
  "alt_text_badge.title": "Алтернативен текст",
  "alt_text_modal.add_alt_text": "Добавяне на алтернативен текст",
  "alt_text_modal.add_text_from_image": "Добавяне на текст от образ",
  "alt_text_modal.cancel": "Отказ",
  "alt_text_modal.change_thumbnail": "Промяна на миниобраза",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Опишете това за хора със слухови увреждания…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Опишете това за хора със зрителни увреждания…",
  "alt_text_modal.done": "Готово",
  "announcement.announcement": "Оповестяване",
  "annual_report.summary.most_used_app.most_used_app": "най-употребявано приложение",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "най-употребяван хаштаг",
  "annual_report.summary.new_posts.new_posts": "нови публикации",
  "annual_report.summary.percentile.text": "<topLabel>Това ви слага най-отгоре</topLabel><percentage></percentage><bottomLabel>сред потребителите на {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Няма да кажем на Бърни Сандърс.",
  "attachments_list.unprocessed": "(необработено)",
  "audio.hide": "Скриване на звука",
  "block_modal.remote_users_caveat": "Ще приканим сървъра {domain} да уважава решението ви. За съжаление не можем да гарантираме това защото някои сървъри могат да третират блокиранията по различен начин. Публичните постове може да продължат да бъдат видими за потребители, които не са се регистрирали.",
  "block_modal.show_less": "Повече на показ",
  "block_modal.show_more": "По-малко на показ",
  "block_modal.they_will_know": "Те могат да видят, че са блокирани.",
  "block_modal.title": "Блокирате ли потребителя?",
  "boost_modal.combo": "Можете да натиснете {combo}, за да пропуснете това следващия път",
  "boost_modal.reblog": "Подсилвате ли публикация?",
  "boost_modal.undo_reblog": "Без подсилване на публикация ли?",
  "bundle_column_error.copy_stacktrace": "Копиране на доклада за грешката",
  "bundle_column_error.error.body": "Заявената страница не може да се изобрази. Това може да е заради грешка в кода ни или проблем със съвместимостта на браузъра.",
  "bundle_column_error.error.title": "О, не!",
  "bundle_column_error.network.body": "Възникна грешка, опитвайки зареждане на страницата. Това може да е заради временен проблем с интернет връзката ви или този сървър.",
  "bundle_column_error.network.title": "Мрежова грешка",
  "bundle_column_error.retry": "Нов опит",
  "bundle_column_error.return": "Обратно към началото",
  "bundle_column_error.routing.body": "Заявената страница не може да се намери. Сигурни ли сте, че URL адресът в адресната лента е правилен?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Затваряне",
  "bundle_modal_error.message": "Нещо се обърка, зареждайки този екран.",
  "bundle_modal_error.retry": "Нов опит",
  "closed_registrations.other_server_instructions": "Oткак e децентрализиранa Mastodon, може да създадете акаунт на друг сървър и още може да взаимодействате с този.",
  "closed_registrations_modal.description": "Създаването на акаунт в {domain} сега не е възможно, но обърнете внимание, че нямате нужда от акаунт конкретно на {domain}, за да ползвате Mastodon.",
  "closed_registrations_modal.find_another_server": "Намиране на друг сървър",
  "closed_registrations_modal.preamble": "Mastodon е децентрализиран, така че няма значение къде създавате акаунта си, ще може да последвате и взаимодействате с всеки на този сървър. Може дори да стартирате свой собствен сървър!",
  "closed_registrations_modal.title": "Регистриране в Mastodon",
  "column.about": "Относно",
  "column.blocks": "Блокирани потребители",
  "column.bookmarks": "Отметки",
  "column.community": "Локална хронология",
  "column.create_list": "Създаване на списък",
  "column.direct": "Частни споменавания",
  "column.directory": "Разглеждане на профили",
  "column.domain_blocks": "Блокирани домейни",
  "column.edit_list": "Промяна на списъка",
  "column.favourites": "Любими",
  "column.firehose": "Инфоканали на живо",
  "column.follow_requests": "Заявки за последване",
  "column.home": "Начало",
  "column.list_members": "Управление на списъка с участници",
  "column.lists": "Списъци",
  "column.mutes": "Заглушени потребители",
  "column.notifications": "Известия",
  "column.pins": "Закачени публикации",
  "column.public": "Федеративна хронология",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Скриване на настройките",
  "column_header.moveLeft_settings": "Преместване на колона вляво",
  "column_header.moveRight_settings": "Преместване на колона вдясно",
  "column_header.pin": "Закачане",
  "column_header.show_settings": "Показване на настройките",
  "column_header.unpin": "Разкачане",
  "column_search.cancel": "Отказ",
  "community.column_settings.local_only": "Само локално",
  "community.column_settings.media_only": "Само мултимедия",
  "community.column_settings.remote_only": "Само отдалечено",
  "compose.error.blank_post": "Публикацията не може да е празна.",
  "compose.language.change": "Смяна на езика",
  "compose.language.search": "Търсене на езици...",
  "compose.published.body": "Публикувано.",
  "compose.published.open": "Отваряне",
  "compose.saved.body": "Запазена публикация.",
  "compose_form.direct_message_warning_learn_more": "Още информация",
  "compose_form.encryption_warning": "Публикациите в Mastodon не са криптирани от край до край. Не споделяйте никаква чувствителна информация там.",
  "compose_form.hashtag_warning": "Тази публикация няма да се вписва под никакъв хаштаг, тъй като не е обществена. Само публични публикации могат да се търсят по хаштаг.",
  "compose_form.lock_disclaimer": "Вашият акаунт не е в положение {locked}. Всеки може да ви последва, за да разглежда публикациите ви само за последователи.",
  "compose_form.lock_disclaimer.lock": "заключено",
  "compose_form.placeholder": "Какво мислите?",
  "compose_form.poll.duration": "Времетраене на анкетата",
  "compose_form.poll.multiple": "Множествен избор",
  "compose_form.poll.option_placeholder": "Избор {number}",
  "compose_form.poll.single": "Единичен избор",
  "compose_form.poll.switch_to_multiple": "Промяна на анкетата, за да се позволят множество възможни избора",
  "compose_form.poll.switch_to_single": "Промяна на анкетата, за да се позволи един възможен избор",
  "compose_form.poll.type": "Стил",
  "compose_form.publish": "Публикация",
  "compose_form.reply": "Отговор",
  "compose_form.save_changes": "Обновяване",
  "compose_form.spoiler.marked": "Отстраняване на предупреждение за съдържание",
  "compose_form.spoiler.unmarked": "Добавяне на предупреждение за съдържание",
  "compose_form.spoiler_placeholder": "Предупреждение за съдържание (по избор)",
  "confirmation_modal.cancel": "Отказ",
  "confirmations.block.confirm": "Блокиране",
  "confirmations.delete.confirm": "Изтриване",
  "confirmations.delete.message": "Наистина ли искате да изтриете публикацията?",
  "confirmations.delete.title": "Изтривате ли публикацията?",
  "confirmations.delete_list.confirm": "Изтриване",
  "confirmations.delete_list.message": "Наистина ли искате да изтриете завинаги списъка?",
  "confirmations.delete_list.title": "Изтривате ли списъка?",
  "confirmations.discard_draft.confirm": "Изхвърляне и продължаване",
  "confirmations.discard_draft.edit.cancel": "Възобновяване на редактиране",
  "confirmations.discard_draft.edit.message": "Продължаването ще изхвърли всякакви промени, които сте правили в публикацията, която сега редактирате.",
  "confirmations.discard_draft.edit.title": "Изхвърляте ли промените в публикацията си?",
  "confirmations.discard_draft.post.cancel": "Възстановка на чернова",
  "confirmations.discard_draft.post.message": "Продължаването ще изхвърли публикацията, която сега съставяте.",
  "confirmations.discard_draft.post.title": "Изхвърляте ли черновата си публикация?",
  "confirmations.discard_edit_media.confirm": "Отхвърляне",
  "confirmations.discard_edit_media.message": "Не сте запазили промени на описанието или огледа на мултимедията, отхвърляте ли ги?",
  "confirmations.follow_to_list.confirm": "Последване и добавяне в списък",
  "confirmations.follow_to_list.message": "Трябва да последвате {name}, за да добавите лицето към списък.",
  "confirmations.follow_to_list.title": "Последвате ли потребителя?",
  "confirmations.logout.confirm": "Излизане",
  "confirmations.logout.message": "Наистина ли искате да излезете?",
  "confirmations.logout.title": "Излизате ли от системата?",
  "confirmations.missing_alt_text.confirm": "Добавяне на алтернативен текст",
  "confirmations.missing_alt_text.message": "Вашата публикация съдържа мултимедия без алтернативен текст. Добавянето на описание помага да направите съдържанието си по-достъпно за повече хора.",
  "confirmations.missing_alt_text.secondary": "Все пак да се публикува",
  "confirmations.missing_alt_text.title": "Добавяте ли алтернативен текст?",
  "confirmations.mute.confirm": "Заглушаване",
  "confirmations.private_quote_notify.cancel": "Назад към редактирането",
  "confirmations.private_quote_notify.confirm": "Издаване на публикация",
  "confirmations.private_quote_notify.do_not_show_again": "Без показване пак на това съобщение",
  "confirmations.quiet_post_quote_info.dismiss": "Без друго напомняне",
  "confirmations.quiet_post_quote_info.got_it": "Схванах",
  "confirmations.quiet_post_quote_info.title": "Цитиране на публикации за тиха публика",
  "confirmations.redraft.confirm": "Изтриване и преработване",
  "confirmations.redraft.message": "Наистина ли искате да изтриете тази публикация и да я направите чернова? Означаванията като любими и подсилванията ще се изгубят, а и отговорите към първоначалната публикация ще осиротеят.",
  "confirmations.redraft.title": "Изтривате и преработвате ли публикацията?",
  "confirmations.remove_from_followers.confirm": "Премахване на последовател",
  "confirmations.remove_from_followers.message": "{name} ще спре да ви следва. Наистина ли искате да продължите?",
  "confirmations.remove_from_followers.title": "Премахвате ли последовател?",
  "confirmations.revoke_quote.confirm": "Премахване на публикация",
  "confirmations.revoke_quote.message": "Действието е неотменимо.",
  "confirmations.revoke_quote.title": "Премахвате ли публикацията?",
  "confirmations.unblock.confirm": "Отблокиране",
  "confirmations.unblock.title": "Отблокирате ли @{name}?",
  "confirmations.unfollow.confirm": "Без следване",
  "confirmations.unfollow.title": "Спирате ли следване на {name}?",
  "confirmations.withdraw_request.confirm": "Оттегляне на заявката",
  "content_warning.hide": "Скриване на публ.",
  "content_warning.show": "Нека се покаже",
  "content_warning.show_more": "Показване на още",
  "conversation.delete": "Изтриване на разговора",
  "conversation.mark_as_read": "Маркиране като прочетено",
  "conversation.open": "Преглед на разговора",
  "conversation.with": "С {names}",
  "copy_icon_button.copied": "Копиранo в буферната памет",
  "copypaste.copied": "Копирано",
  "copypaste.copy_to_clipboard": "Копиране в буферната памет",
  "directory.federated": "От позната федивселена",
  "directory.local": "Само от {domain}",
  "directory.new_arrivals": "Новодошли",
  "directory.recently_active": "Наскоро дейни",
  "disabled_account_banner.account_settings": "Настройки на акаунта",
  "disabled_account_banner.text": "Вашият акаунт {disabledAccount} сега е изключен.",
  "dismissable_banner.community_timeline": "Ето най-скорошните публични публикации от хора, чиито акаунти са разположени в {domain}.",
  "dismissable_banner.dismiss": "Отхвърляне",
  "dismissable_banner.public_timeline": "Ето най-новите обществени публикации от хора във федивселената, която хората в {domain} следват.",
  "domain_block_modal.block": "Блокиране на сървър",
  "domain_block_modal.block_account_instead": "Вместо това блокиране на @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Хората от този сървър могат да взаимодействат с ваши стари публикации.",
  "domain_block_modal.they_cant_follow": "Никого от този сървър не може да ви последва.",
  "domain_block_modal.they_wont_know": "Няма да узнаят, че са били блокирани.",
  "domain_block_modal.title": "Блокирате ли домейн?",
  "domain_block_modal.you_will_lose_num_followers": "Ще загубите {followersCount, plural, one {{followersCountDisplay} последовател} other {{followersCountDisplay} последователи}} и {followingCount, plural, one {{followingCountDisplay} лице, което следвате} other {{followingCountDisplay} души, които следвате}}.",
  "domain_block_modal.you_will_lose_relationships": "Ще загубите всичките си последователи и хората, които следвате от този сървър.",
  "domain_block_modal.you_wont_see_posts": "Няма да виждате публикации или известия от потребителите на този сървър.",
  "domain_pill.activitypub_lets_connect": "Позволява ви да се свързвате и взаимодействате с хора не само в Mastodon, но и през различни социални приложения.",
  "domain_pill.activitypub_like_language": "ActivityPub е като език на Mastodon, говорещ с други социални мрежи.",
  "domain_pill.server": "Сървър",
  "domain_pill.their_handle": "Техният адрес:",
  "domain_pill.their_server": "Цифровият им дом, където живеят всичките им публикации.",
  "domain_pill.their_username": "Неповторимият им идентификатор на сървъра им. Възможно е да се намерят потребители със същото потребителско име на други сървъри.",
  "domain_pill.username": "Потребителско име",
  "domain_pill.whats_in_a_handle": "Как се съставя адресът?",
  "domain_pill.who_they_are": "Адресът показва за някой кой е той и къде се намира. Това ви позволява да общувате с всички в социалната мрежа от <button>платформите поддържащи ActivityPub</button>.",
  "domain_pill.who_you_are": "Адресът ви показва кой сте и къде се намирате. Това ви позволява да общувате с всички в социалната мрежа от <button>платформите поддържащи ActivityPub</button>.",
  "domain_pill.your_handle": "Вашият адрес:",
  "domain_pill.your_server": "Цифровият ви дом, където живеят всичките ви публикации. Не харесвате ли този? Прехвърляте се на сървъри по всяко време и докарвате последователите си също.",
  "domain_pill.your_username": "Неповторимият ви идентификатор на този сървър. Възможно е да се намерят потребители със същото потребителско име на други сървъри.",
  "dropdown.empty": "Изберете възможност",
  "embed.instructions": "Вградете публикацията в уебсайта си, копирайки кода долу.",
  "embed.preview": "Ето как ще изглежда:",
  "emoji_button.activity": "Дейност",
  "emoji_button.clear": "Изчистване",
  "emoji_button.custom": "Персонализирано",
  "emoji_button.flags": "Знамена",
  "emoji_button.food": "Храна и напитки",
  "emoji_button.label": "Вмъкване на емоджи",
  "emoji_button.nature": "Природа",
  "emoji_button.not_found": "Без емоджита!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Предмети",
  "emoji_button.people": "Хора",
  "emoji_button.recent": "Често използвани",
  "emoji_button.search": "Търсене...",
  "emoji_button.search_results": "Резултати от търсене",
  "emoji_button.symbols": "Символи",
  "emoji_button.travel": "Пътуване и места",
  "empty_column.account_hides_collections": "Този потребител е избрал да не дава тази информация",
  "empty_column.account_suspended": "Спрян акаунт",
  "empty_column.account_timeline": "Тук няма публикации!",
  "empty_column.account_unavailable": "Профилът не е наличен",
  "empty_column.blocks": "Още не сте блокирали никакви потребители.",
  "empty_column.bookmarked_statuses": "Още не сте отметнали публикации. Отметвайки някоя, то тя ще се покаже тук.",
  "empty_column.community": "Локалната хронология е празна. Напишете нещо публично, за да завъртите процеса!",
  "empty_column.direct": "Още нямате никакви частни споменавания. Тук ще се показват, изпращайки или получавайки едно.",
  "empty_column.domain_blocks": "Още няма блокирани домейни.",
  "empty_column.explore_statuses": "Няма нищо популярно в момента. Проверете пак по-късно!",
  "empty_column.favourited_statuses": "Още нямате никакви любими публикации. Правейки любима, то тя ще се покаже тук.",
  "empty_column.favourites": "Още никого не е слагал публикацията в любими. Когато някой го направи, този човек ще се покаже тук.",
  "empty_column.follow_requests": "Още нямате заявки за последване. Получавайки такава, то тя ще се покаже тук.",
  "empty_column.followed_tags": "Още не сте последвали никакви хаштагове. Последваните хаштагове ще се покажат тук.",
  "empty_column.hashtag": "Още няма нищо в този хаштаг.",
  "empty_column.home": "Вашата начална хронология е празна! Последвайте повече хора, за да се запълни.",
  "empty_column.list": "Все още списъкът е празен. Членуващите на списъка, публикуващи нови публикации, ще се появят тук.",
  "empty_column.mutes": "Още не сте заглушавали потребители.",
  "empty_column.notification_requests": "Всичко е чисто! Тук няма нищо. Получавайки нови известия, те ще се появят тук според настройките ви.",
  "empty_column.notifications": "Все още нямате известия. Взаимодействайте с другите, за да започнете разговора.",
  "empty_column.public": "Тук няма нищо! Публикувайте нещо или последвайте потребители от други сървъри, за да го напълните",
  "error.unexpected_crash.explanation": "Поради грешка в нашия код или проблем със съвместимостта на браузъра, тази страница не може да се покаже правилно.",
  "error.unexpected_crash.explanation_addons": "Страницата не можа да се покаже правилно. Тази грешка вероятно е причинена от добавка на браузъра или от средства за автоматичен превод.",
  "error.unexpected_crash.next_steps": "Опитайте опресняване на страницата. Ако това не помогне, още може да използвате Mastodon през различен браузър или приложение.",
  "error.unexpected_crash.next_steps_addons": "Опитайте се да ги изключите и да опресните страницата. Ако това не помогне, то още може да използвате Mastodon чрез различен браузър или приложение.",
  "errors.unexpected_crash.copy_stacktrace": "Копиране на трасето на стека в буферната памет",
  "errors.unexpected_crash.report_issue": "Сигнал за проблем",
  "explore.suggested_follows": "Хора",
  "explore.title": "Вървежно",
  "explore.trending_links": "Новини",
  "explore.trending_statuses": "Публикации",
  "explore.trending_tags": "Хаштагове",
  "featured_carousel.header": "{count, plural, one {закачена публикация} other {закачени публикации}}",
  "filter_modal.added.context_mismatch_explanation": "Тази категория филтър не е приложима към контекста, в който достъпвате тази публикация. Ако желаете да филтрирате публикациите в този контекст, трябва да изберете друг филтър.",
  "filter_modal.added.context_mismatch_title": "Несъвпадащ контекст!",
  "filter_modal.added.expired_explanation": "Валидността на тази категория филтър е изтекла. Сменете срока на валидност, за да я приложите.",
  "filter_modal.added.expired_title": "Изтекъл филтър!",
  "filter_modal.added.review_and_configure": "За да прегледате и нагласите тази категория на филтъра, то отидете на {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Настройки на филтъра",
  "filter_modal.added.settings_link": "страница с настройки",
  "filter_modal.added.short_explanation": "Тази публикация е добавена към следната категория на филтъра: {title}.",
  "filter_modal.added.title": "Филтърът е добавен!",
  "filter_modal.select_filter.context_mismatch": "неприложимо за контекста",
  "filter_modal.select_filter.expired": "изтекло",
  "filter_modal.select_filter.prompt_new": "Нова категория: {name}",
  "filter_modal.select_filter.search": "Търсене или създаване",
  "filter_modal.select_filter.subtitle": "Изберете съществуваща категория или създайте нова",
  "filter_modal.select_filter.title": "Филтриране на публ.",
  "filter_modal.title.status": "Филтриране на публ.",
  "filter_warning.matches_filter": "Съвпадащ филтър на “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "От {count, plural, =0 {никого, когото може да познавате} one {едно лице, което може да познавате} other {# души, които може да познавате}}",
  "filtered_notifications_banner.title": "Филтрирани известия",
  "firehose.all": "Всичко",
  "firehose.local": "Този сървър",
  "firehose.remote": "Други сървъри",
  "follow_request.authorize": "Упълномощаване",
  "follow_request.reject": "Отхвърляне",
  "follow_requests.unlocked_explanation": "Въпреки че акаунтът ви не е заключен, служителите на {domain} помислиха, че може да искате да преглеждате ръчно заявките за последване на тези профили.",
  "follow_suggestions.curated_suggestion": "Избор на персонал",
  "follow_suggestions.dismiss": "Без ново показване",
  "follow_suggestions.featured_longer": "Ръчно избрано от отбора на {domain}",
  "follow_suggestions.friends_of_friends_longer": "Популярно измежду хората, които следвате",
  "follow_suggestions.hints.featured": "Този профил е ръчно подбран от отбора на {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Този профил е популярен измежду хората, които следвате.",
  "follow_suggestions.hints.most_followed": "Този профил е един от най-следваните при {domain}.",
  "follow_suggestions.hints.most_interactions": "Този профил наскоро получи много внимание при {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Този профил е подобен на профилите, които сте последвали наскоро.",
  "follow_suggestions.personalized_suggestion": "Персонализирано предложение",
  "follow_suggestions.popular_suggestion": "Популярно предложение",
  "follow_suggestions.popular_suggestion_longer": "Популярно из {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Подобни на профилите, които наскоро сте последвали",
  "follow_suggestions.view_all": "Преглед на всички",
  "follow_suggestions.who_to_follow": "Кого да се следва",
  "followed_tags": "Последвани хаштагове",
  "footer.about": "Относно",
  "footer.directory": "Директория на профилите",
  "footer.get_app": "Вземане на приложението",
  "footer.keyboard_shortcuts": "Клавишни комбинации",
  "footer.privacy_policy": "Политика за поверителност",
  "footer.source_code": "Преглед на изходния код",
  "footer.status": "Състояние",
  "footer.terms_of_service": "Условия на услугата",
  "generic.saved": "Запазено",
  "getting_started.heading": "Първи стъпки",
  "hashtag.admin_moderation": "Отваряне на модериращия интерфейс за #{name}",
  "hashtag.browse": "Разглеждане на публикации в #{hashtag}",
  "hashtag.browse_from_account": "Разглеждане на публикации от @{name} из #{hashtag}",
  "hashtag.column_header.tag_mode.all": "и {additional}",
  "hashtag.column_header.tag_mode.any": "или {additional}",
  "hashtag.column_header.tag_mode.none": "без {additional}",
  "hashtag.column_settings.select.no_options_message": "Няма намерени предложения",
  "hashtag.column_settings.select.placeholder": "Въвеждане на хаштагове…",
  "hashtag.column_settings.tag_mode.all": "Всичко това",
  "hashtag.column_settings.tag_mode.any": "Някое от тези",
  "hashtag.column_settings.tag_mode.none": "Никое от тези",
  "hashtag.column_settings.tag_toggle": "Включва допълнителни хаштагове за тази колона",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} участник} other {{counter} участници}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} публикация} other {{counter} публикации}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} публикация} other {{counter} публикации}} днес",
  "hashtag.follow": "Следване на хаштаг",
  "hashtag.mute": "Заглушаване на #{hashtag}",
  "hashtag.unfollow": "Спиране на следване на хаштаг",
  "hashtags.and_other": "…и {count, plural, other {# още}}",
  "hints.profiles.followers_may_be_missing": "Последователи за този профил може да липсват.",
  "hints.profiles.follows_may_be_missing": "Последванията за този профил може да липсват.",
  "hints.profiles.posts_may_be_missing": "Някои публикации от този профил може да липсват.",
  "hints.profiles.see_more_followers": "Преглед на още последователи на {domain}",
  "hints.profiles.see_more_follows": "Преглед на още последвания на {domain}",
  "hints.profiles.see_more_posts": "Преглед на още публикации на {domain}",
  "home.column_settings.show_quotes": "Показване на цитираното",
  "home.column_settings.show_reblogs": "Показване на подсилванията",
  "home.column_settings.show_replies": "Показване на отговорите",
  "home.hide_announcements": "Скриване на оповестяванията",
  "home.pending_critical_update.body": "Обновете сървъра си в Mastodon възможно най-скоро!",
  "home.pending_critical_update.link": "Преглед на обновяванията",
  "home.pending_critical_update.title": "Налично критично обновяване на сигурността!",
  "home.show_announcements": "Показване на оповестяванията",
  "ignore_notifications_modal.disclaimer": "Mastodon не може да осведоми потребители, че сте пренебрегнали известията им. Пренебрегването на известията няма да спре самите съобщения да не бъдат изпращани.",
  "ignore_notifications_modal.filter_instead": "Вместо това филтриране",
  "ignore_notifications_modal.filter_to_act_users": "Вие все още ще може да приемате, отхвърляте или докладвате потребители",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Прецеждането помага за избягване на възможно объркване",
  "ignore_notifications_modal.filter_to_review_separately": "Може да разгледате отделно филтрираните известия",
  "ignore_notifications_modal.ignore": "Пренебрегване на известията",
  "ignore_notifications_modal.limited_accounts_title": "Пренебрегвате ли известията от модерирани акаунти?",
  "ignore_notifications_modal.new_accounts_title": "Пренебрегвате ли известията от нови акаунти?",
  "ignore_notifications_modal.not_followers_title": "Пренебрегвате ли известията от хора, които не са ви последвали?",
  "ignore_notifications_modal.not_following_title": "Пренебрегвате ли известията от хора, които не сте последвали?",
  "ignore_notifications_modal.private_mentions_title": "Пренебрегвате ли известия от непоискани лични споменавания?",
  "info_button.label": "Помощ",
  "info_button.what_is_alt_text": "<h1>Какво е алтернативен текст?</h1> <p>Алтернативният текст осигурява описания на изображение за хора със зрителни увреждания, връзки с ниска честотна лента или търсещите допълнителен контекст.</p> <p>Може да подобрите достъпността и разбираемостта за всеки, пишейки ясен, кратък и обективен алтернативен текст.</p> <ul> <li>Уловете важните елементи</li> <li>Обобщете текста в образите</li> <li>Употребявайте правилна структура на изречението</li> <li>Избягвайте излишна информация</li> <li>Съсредоточете се върху тенденциите и ключови констатации в сложни онагледявания (като диаграми и карти)</li> </ul>",
  "interaction_modal.action": "Трябва да влезете с акаунта си, в който и да е сървър на Mastodon, когото използвате, за да взаимодействате с публикация на {name}.",
  "interaction_modal.go": "Напред",
  "interaction_modal.no_account_yet": "Още ли нямате акаунт?",
  "interaction_modal.on_another_server": "На различен сървър",
  "interaction_modal.on_this_server": "На този сървър",
  "interaction_modal.title": "Влезте, за да продължите",
  "interaction_modal.username_prompt": "Напр. {example}",
  "intervals.full.days": "{number, plural, one {# ден} other {# дни}}",
  "intervals.full.hours": "{number, plural, one {# час} other {# часа}}",
  "intervals.full.minutes": "{number, plural, one {# минута} other {# минути}}",
  "keyboard_shortcuts.back": "Навигиране назад",
  "keyboard_shortcuts.blocked": "Отваряне на списъка с блокирани потребители",
  "keyboard_shortcuts.boost": "Подсилване на публикация",
  "keyboard_shortcuts.column": "Съсредоточение на колона",
  "keyboard_shortcuts.compose": "Фокус на текстовата зона за съставяне",
  "keyboard_shortcuts.description": "Опис",
  "keyboard_shortcuts.down": "Преместване надолу в списъка",
  "keyboard_shortcuts.enter": "Отваряне на публикация",
  "keyboard_shortcuts.favourite": "Любима публикация",
  "keyboard_shortcuts.favourites": "Отваряне на списъка с любими",
  "keyboard_shortcuts.federated": "Отваряне на федералната хронология",
  "keyboard_shortcuts.heading": "Клавишни съчетания",
  "keyboard_shortcuts.home": "Отваряне на началната хронология",
  "keyboard_shortcuts.hotkey": "Бърз клавиш",
  "keyboard_shortcuts.legend": "Показване на тази легенда",
  "keyboard_shortcuts.local": "Отваряне на локалната хронология",
  "keyboard_shortcuts.mention": "Споменаване на автора",
  "keyboard_shortcuts.muted": "Отваряне на списъка със заглушени потребители",
  "keyboard_shortcuts.my_profile": "Отваряне на профила ви",
  "keyboard_shortcuts.notifications": "Отваряне на колоната с известия",
  "keyboard_shortcuts.open_media": "Отваряне на мултимедията",
  "keyboard_shortcuts.pinned": "Отваряне на списъка със закачени публикации",
  "keyboard_shortcuts.profile": "Отваряне на профила на автора",
  "keyboard_shortcuts.reply": "Отговаряне на публикация",
  "keyboard_shortcuts.requests": "Отваряне на списъка със заявки за последване",
  "keyboard_shortcuts.search": "Фокус на лентата за търсене",
  "keyboard_shortcuts.spoilers": "Показване/скриване на полето за предупреждение на съдържание",
  "keyboard_shortcuts.start": "Отваряне на колоната \"първи стъпки\"",
  "keyboard_shortcuts.toggle_hidden": "Показване/скриване на текст зад предупреждение на съдържание",
  "keyboard_shortcuts.toggle_sensitivity": "Показване/скриване на мултимедията",
  "keyboard_shortcuts.toot": "Начало на нова публикация",
  "keyboard_shortcuts.translate": "за превод на публикация",
  "keyboard_shortcuts.unfocus": "Разфокусиране на текстовото поле за съставяне/търсене",
  "keyboard_shortcuts.up": "Преместване нагоре в списъка",
  "learn_more_link.got_it": "Разбрах",
  "learn_more_link.learn_more": "Научете повече",
  "lightbox.close": "Затваряне",
  "lightbox.next": "Напред",
  "lightbox.previous": "Назад",
  "lightbox.zoom_in": "Увеличение до действителната големина",
  "lightbox.zoom_out": "Увеличение до побиране",
  "limited_account_hint.action": "Показване на профила въпреки това",
  "limited_account_hint.title": "Този профил е бил скрит от модераторите на {domain}.",
  "link_preview.author": "От {name}",
  "link_preview.more_from_author": "Още от {name}",
  "link_preview.shares": "{count, plural, one {{counter} публикация} other {{counter} публикации}}",
  "lists.add_member": "Добавяне",
  "lists.add_to_list": "Добавяне в списък",
  "lists.add_to_lists": "Добавяне на {name} в списъци",
  "lists.create": "Създаване",
  "lists.create_a_list_to_organize": "Сътворете нов списък, за да организирате инфоканала си на Начало",
  "lists.create_list": "Създаване на списък",
  "lists.delete": "Изтриване на списъка",
  "lists.done": "Готово",
  "lists.edit": "Промяна на списъка",
  "lists.exclusive": "Скриване на членуващи в Начало",
  "lists.exclusive_hint": "Ако някой е в този списък, то скрийте го в инфоканала си на Начало, за да избегнете виждането на публикациите му два пъти.",
  "lists.find_users_to_add": "Намерете потребители за добавяне",
  "lists.list_members_count": "{count, plural, one {# членуващ} other {# членуващи}}",
  "lists.list_name": "Име на списък",
  "lists.new_list_name": "Ново име на списък",
  "lists.no_lists_yet": "Още няма списъци.",
  "lists.no_members_yet": "Още няма членуващи.",
  "lists.no_results_found": "Няма намерени резултати.",
  "lists.remove_member": "Премахване",
  "lists.replies_policy.followed": "Някой последван потребител",
  "lists.replies_policy.list": "Членуващите в списъка",
  "lists.replies_policy.none": "Никого",
  "lists.save": "Запазване",
  "lists.search": "Търсене",
  "lists.show_replies_to": "Включва отговори от членуващи в списъка до",
  "load_pending": "{count, plural, one {# нов елемент} other {# нови елемента}}",
  "loading_indicator.label": "Зареждане…",
  "media_gallery.hide": "Скриване",
  "moved_to_account_banner.text": "Вашият акаунт {disabledAccount} сега е изключен, защото се преместихте в {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Скриване от известията",
  "mute_modal.hide_options": "Скриване на възможностите",
  "mute_modal.indefinite": "Докато премахна заглушаването им",
  "mute_modal.show_options": "Показване на възможностите",
  "mute_modal.they_can_mention_and_follow": "Могат да ви споменават и последват, но няма да ги виждате.",
  "mute_modal.they_wont_know": "Няма да узнаят, че са били заглушени.",
  "mute_modal.title": "Заглушавате ли потребител?",
  "mute_modal.you_wont_see_mentions": "Няма да виждате споменаващите ги публикации.",
  "mute_modal.you_wont_see_posts": "Още могат да виждат публикациите ви, но вие техните не.",
  "navigation_bar.about": "Относно",
  "navigation_bar.account_settings": "Парола и сигурност",
  "navigation_bar.administration": "Администрация",
  "navigation_bar.advanced_interface": "Отваряне в разширен уебинтерфейс",
  "navigation_bar.automated_deletion": "Автоматично изтриване на публикации",
  "navigation_bar.blocks": "Блокирани потребители",
  "navigation_bar.bookmarks": "Отметки",
  "navigation_bar.direct": "Частни споменавания",
  "navigation_bar.domain_blocks": "Блокирани домейни",
  "navigation_bar.favourites": "Любими",
  "navigation_bar.filters": "Заглушени думи",
  "navigation_bar.follow_requests": "Заявки за последване",
  "navigation_bar.followed_tags": "Последвани хаштагове",
  "navigation_bar.follows_and_followers": "Последвания и последователи",
  "navigation_bar.import_export": "Внасяне и изнасяне",
  "navigation_bar.lists": "Списъци",
  "navigation_bar.logout": "Излизане",
  "navigation_bar.moderation": "Модериране",
  "navigation_bar.more": "Още",
  "navigation_bar.mutes": "Заглушени потребители",
  "navigation_bar.opened_in_classic_interface": "Публикации, акаунти и други особени страници се отварят по подразбиране в класическия мрежови интерфейс.",
  "navigation_bar.preferences": "Предпочитания",
  "navigation_bar.privacy_and_reach": "Поверителност и обхват",
  "navigation_bar.search": "Търсене",
  "navigation_bar.search_trends": "Търсене / Вървежно",
  "not_signed_in_indicator.not_signed_in": "Трябва ви вход за достъп до ресурса.",
  "notification.admin.report": "{name} докладва {target}",
  "notification.admin.report_account": "{name} докладва {count, plural, one {публикация} other {# публикации}} от {target} за {category}",
  "notification.admin.report_account_other": "{name} докладва {count, plural, one {публикация} other {# публикации}} от {target}",
  "notification.admin.report_statuses": "{name} докладва {target} за {category}",
  "notification.admin.report_statuses_other": "{name} докладва {target}",
  "notification.admin.sign_up": "{name} се регистрира",
  "notification.admin.sign_up.name_and_others": "{name} и {count, plural, one {# друг} other {# други}} се регистрираха",
  "notification.annual_report.message": "#Wrapstodon за {year} година ви очаква! Свалете булото на изтъкнатото и паметните моменти за годината си в Mastodon!",
  "notification.annual_report.view": "Преглед на #Wrapstodon",
  "notification.favourite": "{name} направи любима публикацията ви",
  "notification.favourite.name_and_others_with_link": "{name} и <a>{count, plural, one {# друг} other {# други}}</a> направиха любима ваша публикация",
  "notification.favourite_pm": "{name} хареса вашето лично споменаване",
  "notification.favourite_pm.name_and_others_with_link": "{name} и <a>{count, plural, one {# друг} other {# други}}</a> харесаха вашето частно споменаване",
  "notification.follow": "{name} ви последва",
  "notification.follow.name_and_others": "{name} и <a>{count, plural, one {# друг} other {# други}}</a> ви последваха",
  "notification.follow_request": "{name} поиска да ви последва",
  "notification.follow_request.name_and_others": "{name} и {count, plural, one {# друг} other {# други}} поискаха да ви последват",
  "notification.label.mention": "Споменаване",
  "notification.label.private_mention": "Частно споменаване",
  "notification.label.private_reply": "Личен отговор",
  "notification.label.quote": "{name} цитира ваша публикация",
  "notification.label.reply": "Отговор",
  "notification.mention": "Споменаване",
  "notification.mentioned_you": "{name} ви спомена",
  "notification.moderation-warning.learn_more": "Научете повече",
  "notification.moderation_warning": "Получихте предупреждение за модериране",
  "notification.moderation_warning.action_delete_statuses": "Някои от публикациите ви са премахнати.",
  "notification.moderation_warning.action_disable": "Вашият акаунт е изключен.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Някои от публикациите ви са означени като деликатни.",
  "notification.moderation_warning.action_none": "Акаунтът ви получи предупреждение за модериране.",
  "notification.moderation_warning.action_sensitive": "Публикациите ви ще се означават като деликатни от сега нататък.",
  "notification.moderation_warning.action_silence": "Вашият акаунт е ограничен.",
  "notification.moderation_warning.action_suspend": "Вашият акаунт е спрян.",
  "notification.own_poll": "Анкетата ви приключи",
  "notification.poll": "Анкета, в която гласувахте, приключи",
  "notification.quoted_update": "{name} редактира публикация, която цитирахте",
  "notification.reblog": "{name} подсили ваша публикация",
  "notification.reblog.name_and_others_with_link": "{name} и <a>{count, plural, one {# друг} other {# други}}</a> подсилиха ваша публикация",
  "notification.relationships_severance_event": "Изгуби се връзката с {name}",
  "notification.relationships_severance_event.account_suspension": "Администратор от {from} спря {target}, което значи че повече не може да получавате новости от тях или да взаимодействате с тях.",
  "notification.relationships_severance_event.domain_block": "Администратор от {from} блокира {target}, вкючващо {followersCount} от последователите ви и {followingCount, plural, one {# акаунт, който} other {# акаунта, които}} следвате.",
  "notification.relationships_severance_event.learn_more": "Научете повече",
  "notification.relationships_severance_event.user_domain_block": "Блокирахте {target}, премахвайки {followersCount} от последователите си и {followingCount, plural, one {# акаунт, който} other {# акаунта, които}} следвате.",
  "notification.status": "{name} току-що публикува",
  "notification.update": "{name} промени публикация",
  "notification_requests.accept": "Приемам",
  "notification_requests.accept_multiple": "{count, plural, one {Приемане на # заявка…} other {Приемане на # заявки…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Приемане на заявката} other {Приемане на заявките}}",
  "notification_requests.confirm_accept_multiple.message": "На път сте да приемете {count, plural, one {едно известие за заявка} other {# известия за заявки}}. Наистина ли искате да продължите?",
  "notification_requests.confirm_accept_multiple.title": "Приемате ли заявките за известие?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Отхвърляне на заявката} other {Отхвърляне на заявките}}",
  "notification_requests.confirm_dismiss_multiple.message": "На път сте да отхвърлите {count, plural, one {една заявка за известие} other {# заявки за известие}}. Няма да имате лесен достъп до {count, plural, one {това лице} other {тях}} отново. Наистина ли искате да продължите?",
  "notification_requests.confirm_dismiss_multiple.title": "Отхвърляте ли заявките за известие?",
  "notification_requests.dismiss": "Отхвърлям",
  "notification_requests.dismiss_multiple": "{count, plural, one {Отхвърляне на # заявка…} other {Отхвърляне на # заявки…}}",
  "notification_requests.edit_selection": "Редактиране",
  "notification_requests.exit_selection": "Готово",
  "notification_requests.explainer_for_limited_account": "Известията от този акаунт са прецедени, защото акаунтът е ограничен от модератор.",
  "notification_requests.explainer_for_limited_remote_account": "Известията от този акаунт са прецедени, защото акаунтът или сървърът му е ограничен от модератор.",
  "notification_requests.maximize": "Максимизиране",
  "notification_requests.minimize_banner": "Минимизиране на банера за филтрирани известия",
  "notification_requests.notifications_from": "Известия от {name}",
  "notification_requests.title": "Филтрирани известия",
  "notification_requests.view": "Преглед на известията",
  "notifications.clear": "Изчистване на известията",
  "notifications.clear_confirmation": "Наистина ли искате да изчистите завинаги всичките си известия?",
  "notifications.clear_title": "Изчиствате ли известията?",
  "notifications.column_settings.admin.report": "Нови доклади:",
  "notifications.column_settings.admin.sign_up": "Нови регистрации:",
  "notifications.column_settings.alert": "Известия на работния плот",
  "notifications.column_settings.favourite": "Любими:",
  "notifications.column_settings.filter_bar.advanced": "Показване на всички категории",
  "notifications.column_settings.filter_bar.category": "Лента за бърз филтър",
  "notifications.column_settings.follow": "Нови последователи:",
  "notifications.column_settings.follow_request": "Нови заявки за последване:",
  "notifications.column_settings.group": "Групиране",
  "notifications.column_settings.mention": "Споменавания:",
  "notifications.column_settings.poll": "Резултати от анкета:",
  "notifications.column_settings.push": "Изскачащи известия",
  "notifications.column_settings.quote": "Цитати:",
  "notifications.column_settings.reblog": "Подсилвания:",
  "notifications.column_settings.show": "Показване в колоната",
  "notifications.column_settings.sound": "Пускане на звук",
  "notifications.column_settings.status": "Нови публикации:",
  "notifications.column_settings.unread_notifications.category": "Непрочетени известия",
  "notifications.column_settings.unread_notifications.highlight": "Изтъкване на непрочетените известия",
  "notifications.column_settings.update": "Промени:",
  "notifications.filter.all": "Всичко",
  "notifications.filter.boosts": "Подсилвания",
  "notifications.filter.favourites": "Любими",
  "notifications.filter.follows": "Последвания",
  "notifications.filter.mentions": "Споменавания",
  "notifications.filter.polls": "Резултати от анкетата",
  "notifications.filter.statuses": "Новости от последваните",
  "notifications.grant_permission": "Даване на разрешение.",
  "notifications.group": "{count} известия",
  "notifications.mark_as_read": "Отбелязване на всички известия като прочетени",
  "notifications.permission_denied": "Известията на работния плот не са налични поради предварително отказана заявка за разрешение в браузъра",
  "notifications.permission_denied_alert": "Известията на работния плот не могат да се включат, тъй като разрешението на браузъра е отказвано преди",
  "notifications.permission_required": "Известията на работния плот ги няма, щото няма дадено нужното позволение.",
  "notifications.policy.accept": "Приемам",
  "notifications.policy.accept_hint": "Показване в известия",
  "notifications.policy.drop": "Пренебрегване",
  "notifications.policy.drop_hint": "Изпращане в празнотата, за да не се видим никога пак",
  "notifications.policy.filter": "Филтър",
  "notifications.policy.filter_hint": "Изпращане до филтрираните входящи за известия",
  "notifications.policy.filter_limited_accounts_hint": "Ограничено от модераторите на сървъра",
  "notifications.policy.filter_limited_accounts_title": "Модерирани акаунти",
  "notifications.policy.filter_new_accounts.hint": "Сътворено през {days, plural, one {последния ден} other {последните # дена}}",
  "notifications.policy.filter_new_accounts_title": "Нови акаунти",
  "notifications.policy.filter_not_followers_hint": "Включително хора, които са ви последвали по-малко от {days, plural, one {ден} other {# дни}}",
  "notifications.policy.filter_not_followers_title": "Хора, които не ви следват",
  "notifications.policy.filter_not_following_hint": "Докато не ги одобрите ръчно",
  "notifications.policy.filter_not_following_title": "Хора, които не следвате",
  "notifications.policy.filter_private_mentions_hint": "Филтрирано, освен ако е отговор към ваше собствено споменаване или ако следвате подателя",
  "notifications.policy.filter_private_mentions_title": "Непоискани частни споменавания",
  "notifications.policy.title": "Управление на известията от…",
  "notifications_permission_banner.enable": "Включване на известията на работния плот",
  "notifications_permission_banner.how_to_control": "За да получавате известия, когато Mastodon не е отворен, включете известията на работния плот. Може да управлявате точно кои видове взаимодействия пораждат известия на работния плот чрез бутона {icon} по-горе, след като бъдат включени.",
  "notifications_permission_banner.title": "Никога не пропускайте нищо",
  "onboarding.follows.back": "Назад",
  "onboarding.follows.empty": "За съжаление, в момента не могат да се показват резултати. Може да опитате посредством търсене или сърфиране да разгледате страницата, за да намерите хора за последване, или опитайте пак по-късно.",
  "onboarding.follows.search": "Търсене",
  "onboarding.follows.title": "Последвайте хора, за да започнете",
  "onboarding.profile.discoverable": "Правене на моя профил откриваем",
  "onboarding.profile.discoverable_hint": "Включвайки откриваемостта в Mastodon, вашите публикации може да се появят при резултатите от търсене и изгряващи неща, и вашия профил може да бъде предложен на хора с подобни интереси като вашите.",
  "onboarding.profile.display_name": "Показвано име",
  "onboarding.profile.display_name_hint": "Вашето пълно име или псевдоним…",
  "onboarding.profile.note": "Биография",
  "onboarding.profile.note_hint": "Може да @споменавате други хора или #хаштагове…",
  "onboarding.profile.title": "Настройване на профила",
  "onboarding.profile.upload_avatar": "Качване на снимка на профила",
  "onboarding.profile.upload_header": "Качване на заглавка на профила",
  "password_confirmation.exceeds_maxlength": "Потвърждаването на паролата превишава максимално допустимата дължина за парола",
  "password_confirmation.mismatching": "Потвърждаването на паролата не съвпада",
  "picture_in_picture.restore": "Връщане обратно",
  "poll.closed": "Затворено",
  "poll.refresh": "Опресняване",
  "poll.reveal": "Преглед на резултатите",
  "poll.total_people": "{count, plural, one {# човек} other {# души}}",
  "poll.total_votes": "{count, plural, one {# глас} other {# гласа}}",
  "poll.vote": "Гласуване",
  "poll.voted": "Гласувахте за този отговор",
  "poll.votes": "{votes, plural, one {# глас} other {# гласа}}",
  "poll_button.add_poll": "Анкетиране",
  "poll_button.remove_poll": "Премахване на анкета",
  "privacy.change": "Промяна на поверителността на публикация",
  "privacy.direct.long": "Споменатите в публикацията",
  "privacy.direct.short": "Частно споменаване",
  "privacy.private.long": "Само последователите ви",
  "privacy.private.short": "Последователи",
  "privacy.public.long": "Всеки във и извън Mastodon",
  "privacy.public.short": "Публично",
  "privacy.quote.disabled": "{visibility}, цитатите са изключени",
  "privacy.quote.limited": "{visibility}, цитатите са ограничени",
  "privacy.unlisted.additional": "Това действие е точно като публичното, с изключение на това, че публикацията няма да се появява в каналите на живо, хаштаговете, разглеждането или търсенето в Mastodon, дори ако сте избрали да се публично видими на ниво акаунт.",
  "privacy.unlisted.short": "Тиха публика",
  "privacy_policy.last_updated": "Последно осъвременяване на {date}",
  "privacy_policy.title": "Политика за поверителност",
  "quote_error.edit": "Не може да се добавят цитати, редайтирайки публикация.",
  "quote_error.poll": "Не може да се цитира при анкетиране.",
  "quote_error.unauthorized": "Нямате право да цитирате тази публикация.",
  "quote_error.upload": "Цитирането не е позволено с мултимедийни прикачвания.",
  "recommended": "Препоръчано",
  "refresh": "Опресняване",
  "regeneration_indicator.please_stand_by": "Изчакайте.",
  "regeneration_indicator.preparing_your_home_feed": "Подготовка на вашия инфоканал начало…",
  "relative_time.days": "{number} д.",
  "relative_time.full.days": "преди {number, plural, one {# ден} other {# дни}}",
  "relative_time.full.hours": "преди {number, plural, one {# час} other {# часа}}",
  "relative_time.full.just_now": "току-що",
  "relative_time.full.minutes": "преди {number, plural, one {# минута} other {# минути}}",
  "relative_time.full.seconds": "преди {number, plural, one {# секунда} other {# секунди}}",
  "relative_time.hours": "{number}ч.",
  "relative_time.just_now": "сега",
  "relative_time.minutes": "{number}м.",
  "relative_time.seconds": "{number}с.",
  "relative_time.today": "днес",
  "remove_quote_hint.button_label": "Схванах",
  "remove_quote_hint.message": "Може да го направите от менюто възможности {icon}.",
  "reply_indicator.attachments": "{count, plural, one {# прикаване} other {# прикачвания}}",
  "reply_indicator.cancel": "Отказ",
  "reply_indicator.poll": "Анкета",
  "report.block": "Блокиране",
  "report.block_explanation": "Няма да им виждате публикациите. Те няма да могат да виждат публикациите ви или да ви последват. Те ще могат да казват, че са били блокирани.",
  "report.categories.legal": "Правни въпроси",
  "report.categories.other": "Друго",
  "report.categories.spam": "Спам",
  "report.categories.violation": "Съдържание, нарушаващо едно или повече правила на сървъра",
  "report.category.subtitle": "Изберете най-доброто съвпадение",
  "report.category.title": "Разкажете ни какво се случва с това: {type}",
  "report.category.title_account": "профил",
  "report.category.title_status": "публикация",
  "report.close": "Готово",
  "report.comment.title": "Има ли нещо друго, което смятате, че трябва да знаем?",
  "report.forward": "Препращане до {target}",
  "report.forward_hint": "Акаунтът е от друг сървър. Ще изпратите ли безимено копие на доклада и там?",
  "report.mute": "Заглушаване",
  "report.mute_explanation": "Няма да виждате публикациите на това лице. То още може да ви следва и да вижда публикациите ви и няма да знае, че е заглушено.",
  "report.next": "Напред",
  "report.placeholder": "Допълнителни коментари",
  "report.reasons.dislike": "Не ми харесва",
  "report.reasons.dislike_description": "Не е нещо, което искате да виждате",
  "report.reasons.legal": "Незаконно е",
  "report.reasons.legal_description": "Смятате, че това нарушава закона на вашата страна или държавата на сървъра",
  "report.reasons.other": "Нещо друго е",
  "report.reasons.other_description": "Проблемът не попада в нито една от останалите категории",
  "report.reasons.spam": "Спам е",
  "report.reasons.spam_description": "Зловредни връзки, фалшиви ангажименти, или повтарящи се отговори",
  "report.reasons.violation": "Нарушава правилата на сървъра",
  "report.reasons.violation_description": "Наясно сте, че нарушава особени правила",
  "report.rules.subtitle": "Изберете всичко, което да се прилага",
  "report.rules.title": "Кои правила са нарушени?",
  "report.statuses.subtitle": "Изберете всичко, което да се прилага",
  "report.statuses.title": "Има ли някакви публикации, подкрепящи доклада?",
  "report.submit": "Подаване",
  "report.target": "Докладване на {target}",
  "report.thanks.take_action": "Ето възможностите ви за управление какво виждате в Mastodon:",
  "report.thanks.take_action_actionable": "Докато преглеждаме това, може да предприемете действие срещу @{name}:",
  "report.thanks.title": "Не искате ли да виждате това?",
  "report.thanks.title_actionable": "Благодарности за докладването, ще го прегледаме.",
  "report.unfollow": "Стоп на следването на @{name}",
  "report.unfollow_explanation": "Последвали сте този акаунт. За да не виждате повече публикациите му в началния си инфопоток, спрете да го следвате.",
  "report_notification.attached_statuses": "{count, plural, one {прикаченa {count} публикация} other {прикачени {count} публикации}}",
  "report_notification.categories.legal": "Правни въпроси",
  "report_notification.categories.legal_sentence": "незаконно съдържание",
  "report_notification.categories.other": "Друго",
  "report_notification.categories.other_sentence": "друго",
  "report_notification.categories.spam": "Спам",
  "report_notification.categories.spam_sentence": "спам",
  "report_notification.categories.violation": "Нарушение на правилото",
  "report_notification.categories.violation_sentence": "нарушение на правило",
  "report_notification.open": "Отваряне на доклада",
  "search.clear": "Изчистване на търсенето",
  "search.no_recent_searches": "Няма скорошни търсения",
  "search.placeholder": "Търсене",
  "search.quick_action.account_search": "Съвпадение на профили {x}",
  "search.quick_action.go_to_account": "Към профил {x}",
  "search.quick_action.go_to_hashtag": "Към хаштаг {x}",
  "search.quick_action.open_url": "Отваряне на URL адреса в Mastodon",
  "search.quick_action.status_search": "Съвпадение на публикации {x}",
  "search.search_or_paste": "Търсене/поставяне на URL",
  "search_popout.full_text_search_disabled_message": "Не е налично на {domain}.",
  "search_popout.full_text_search_logged_out_message": "Достъпно само при влизане в системата.",
  "search_popout.language_code": "Код на езика по ISO",
  "search_popout.options": "Възможности при търсене",
  "search_popout.quick_actions": "Бързи действия",
  "search_popout.recent": "Скорошни търсения",
  "search_popout.specific_date": "особена дата",
  "search_popout.user": "потребител",
  "search_results.accounts": "Профили",
  "search_results.all": "Всичко",
  "search_results.hashtags": "Хаштагове",
  "search_results.no_results": "Няма намерени резултати.",
  "search_results.no_search_yet": "Опитайте да потърсите постове, профили или хаштагове.",
  "search_results.see_all": "Поглед на всички",
  "search_results.statuses": "Публикации",
  "search_results.title": "Търсене на \"{q}\"",
  "server_banner.about_active_users": "Ползващите сървъра през последните 30 дни (дейните месечно потребители)",
  "server_banner.active_users": "дейни потребители",
  "server_banner.administered_by": "Администрира се от:",
  "server_banner.is_one_of_many": "{domain} е един от многото независими сървъри на Mastodon, които може да употребявате, за да участвате във федивселената.",
  "server_banner.server_stats": "Статистика на сървъра:",
  "sign_in_banner.create_account": "Създаване на акаунт",
  "sign_in_banner.follow_anyone": "Последвайте някого през федивселената и вижте всичко в хронологичен ред. Без алгоритми, реклами, или примамващи връзки в полезрението.",
  "sign_in_banner.mastodon_is": "Mastodon е най-добрия начин да бъдете в крак със случващото се.",
  "sign_in_banner.sign_in": "Вход",
  "sign_in_banner.sso_redirect": "Влизане или регистриране",
  "status.admin_account": "Отваряне на интерфейс за модериране за @{name}",
  "status.admin_domain": "Отваряне на модериращия интерфейс за {domain}",
  "status.admin_status": "Отваряне на публикацията в модериращия интерфейс",
  "status.all_disabled": "Подсилването и цитатите са изключени",
  "status.block": "Блокиране на @{name}",
  "status.bookmark": "Отмятане",
  "status.cancel_reblog_private": "Край на подсилването",
  "status.cannot_quote": "Не е позволено да цитирате тази публикация",
  "status.cannot_reblog": "Публикацията не може да се подсилва",
  "status.context.loading": "Зареждане на още отговори",
  "status.context.loading_error": "Не можаха да се заредят нови отговори",
  "status.context.loading_success": "Новите отговори заредени",
  "status.context.more_replies_found": "Още намерени отговори",
  "status.context.retry": "Друг опит",
  "status.context.show": "Показване",
  "status.continued_thread": "Продължена нишка",
  "status.copy": "Копиране на връзката към публикация",
  "status.delete": "Изтриване",
  "status.delete.success": "Публикацията е изтрита",
  "status.detailed_status": "Подробен изглед на разговора",
  "status.direct": "Частно споменаване на @{name}",
  "status.direct_indicator": "Частно споменаване",
  "status.edit": "Редактиране",
  "status.edited": "Последно редактирано на {date}",
  "status.edited_x_times": "Редактирано {count, plural,one {{count} път} other {{count} пъти}}",
  "status.embed": "Вземане на кода за вграждане",
  "status.favourite": "Любимо",
  "status.filter": "Филтриране на публ.",
  "status.history.created": "{name} създаде {date}",
  "status.history.edited": "{name} редактира {date}",
  "status.load_more": "Зареждане на още",
  "status.media.open": "Щракване за отваряне",
  "status.media.show": "Щракване за показване",
  "status.media_hidden": "Мултимедията е скрита",
  "status.mention": "Споменаване на @{name}",
  "status.more": "Още",
  "status.mute": "Заглушаване на @{name}",
  "status.mute_conversation": "Заглушаване на разговора",
  "status.open": "Разширяване на публикацията",
  "status.pin": "Закачане в профила",
  "status.quote_error.filtered": "Скрито поради един от филтрите ви",
  "status.quote_error.limited_account_hint.title": "Този акаунт е бил скрит от модераторите на {domain}.",
  "status.quote_error.not_available": "Неналична публикация",
  "status.quote_error.pending_approval": "Публикацията чака одобрение",
  "status.quote_error.revoked": "Премахната публикация от автора",
  "status.quote_followers_only": "Само последователи могат да цитират тази публикация",
  "status.quote_manual_review": "Авторът ще преглежда ръчно",
  "status.quote_policy_change": "Промяна кой може да цитира",
  "status.quote_post_author": "Цитирах публикация от @{name}",
  "status.quote_private": "Частните публикации не може да се цитират",
  "status.read_more": "Още за четене",
  "status.reblog": "Подсилване",
  "status.reblog_or_quote": "Подсилване или цитиране",
  "status.reblog_private": "Споделете пак с последователите си",
  "status.reblogged_by": "{name} подсили",
  "status.reblogs.empty": "Още никого не е подсилвал публикацията. Подсилващият ще се покаже тук.",
  "status.redraft": "Изтриване и преработване",
  "status.remove_bookmark": "Премахване на отметката",
  "status.remove_favourite": "Премахване от любими",
  "status.remove_quote": "Премахване",
  "status.replied_in_thread": "Отговорено в нишката",
  "status.replied_to": "В отговор до {name}",
  "status.reply": "Отговор",
  "status.replyAll": "Отговор на нишка",
  "status.report": "Докладване на @{name}",
  "status.request_quote": "Заявка за цитиране",
  "status.revoke_quote": "Премахване на моя публикация от публикацията на @{name}",
  "status.sensitive_warning": "Деликатно съдържание",
  "status.share": "Споделяне",
  "status.show_less_all": "Показване на по-малко за всички",
  "status.show_more_all": "Показване на повече за всички",
  "status.show_original": "Показване на първообраза",
  "status.title.with_attachments": "{user} публикува {attachmentCount, plural, one {прикачване} other {{attachmentCount} прикачвания}}",
  "status.translate": "Превод",
  "status.translated_from_with": "Преведено от {lang}, използвайки {provider}",
  "status.uncached_media_warning": "Онагледяването не е налично",
  "status.unmute_conversation": "Без заглушаването на разговора",
  "status.unpin": "Разкачане от профила",
  "subscribed_languages.lead": "Публикации само на избрани езици ще се явяват в началото ви и в хронологичните списъци след промяната. Изберете \"нищо\", за да получавате публикации на всички езици.",
  "subscribed_languages.save": "Запазване на промените",
  "subscribed_languages.target": "Промяна на абонираните езици за {target}",
  "tabs_bar.home": "Начало",
  "tabs_bar.menu": "Меню",
  "tabs_bar.notifications": "Известия",
  "tabs_bar.publish": "Нова публикация",
  "tabs_bar.search": "Търсене",
  "terms_of_service.effective_as_of": "В сила от {date}",
  "terms_of_service.title": "Условия на услугата",
  "terms_of_service.upcoming_changes_on": "Предстоящи промени на {date}",
  "time_remaining.days": "{number, plural, one {остава # ден} other {остават # дни}}",
  "time_remaining.hours": "{number, plural, one {остава # час} other {остават # часа}}",
  "time_remaining.minutes": "{number, plural, one {остава # минута} other {остават # минути}}",
  "time_remaining.moments": "Оставащи моменти",
  "time_remaining.seconds": "{number, plural, one {# секунда} other {# секунди}} остава",
  "trends.counter_by_accounts": "{count, plural, one {{counter} човек} other {{counter} души}} {days, plural, one {за последния {days} ден} other {за последните {days} дни}}",
  "trends.trending_now": "Налагащи се сега",
  "ui.beforeunload": "Черновата ви ще се загуби, излизайки от Mastodon.",
  "units.short.billion": "{count}млрд",
  "units.short.million": "{count}млн",
  "units.short.thousand": "{count}хил",
  "upload_area.title": "Влачене и пускане за качване",
  "upload_button.label": "Добавете файл с образ, видео или звук",
  "upload_error.limit": "Превишено ограничението за качване на файлове.",
  "upload_error.poll": "Качването на файлове не е позволено с анкети.",
  "upload_error.quote": "Цитирайки, не може да качвате файл.",
  "upload_form.drag_and_drop.instructions": "Натиснете интервал или enter, за да подберете мултимедийно прикачване. Провлачвайки, ползвайте клавишите със стрелки, за да премествате мултимедията във всяка дадена посока. Натиснете пак интервал или enter, за да се стовари мултимедийното прикачване в новото си положение или натиснете Esc за отмяна.",
  "upload_form.drag_and_drop.on_drag_cancel": "Провлачването е отменено. Мултимедийното прикачване {item} е спуснато.",
  "upload_form.drag_and_drop.on_drag_end": "Мултимедийното прикачване {item} е спуснато.",
  "upload_form.drag_and_drop.on_drag_over": "Мултимедийното прикачване {item} е преместено.",
  "upload_form.drag_and_drop.on_drag_start": "Избрано мултимедийно прикачване {item}.",
  "upload_form.edit": "Редактиране",
  "upload_progress.label": "Качване...",
  "upload_progress.processing": "Обработка…",
  "username.taken": "Това потребителско име е взето. Опитайте друго",
  "video.close": "Затваряне на видеото",
  "video.download": "Изтегляне на файла",
  "video.exit_fullscreen": "Изход от цял екран",
  "video.expand": "Разгъване на видеото",
  "video.fullscreen": "Цял екран",
  "video.hide": "Скриване на видеото",
  "video.mute": "Заглушаване",
  "video.pause": "Пауза",
  "video.play": "Пускане",
  "video.skip_backward": "Прескок назад",
  "video.skip_forward": "Прескок напред",
  "video.unmute": "Без заглушаване",
  "video.volume_down": "Намаляване на звука",
  "video.volume_up": "Увеличаване на звука",
  "visibility_modal.button_title": "Задаване на видимост",
  "visibility_modal.header": "Видимост и взаимодействие",
  "visibility_modal.helper.privacy_editing": "Видимостта не може да се променя след публикуване на публикацията.",
  "visibility_modal.helper.privacy_private_self_quote": "Самоцитирането на частни публикации не може да се огласява публично.",
  "visibility_modal.instructions": "Управлява кой може да взаимодейства с тази публикация. Може също да приложите настройките за всички бъдещи публикации, навигирайки към <link>Предпочитания > Публикуване по подразбиране</link>.",
  "visibility_modal.privacy_label": "Видимост",
  "visibility_modal.quote_followers": "Само последователи",
  "visibility_modal.quote_label": "Кой може да цитира",
  "visibility_modal.quote_nobody": "Само аз",
  "visibility_modal.quote_public": "Някой",
  "visibility_modal.save": "Запазване"
}
